module.exports = __webpack_public_path__ + "img/yoseka_banner.2d51ce70.png";